import { apiService } from '../APIService';

const PATH = '/plan-announcements';

export default {
  getAll(params) {
    return apiService.get(PATH, params);
  },
  getOne(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },
  /**
   *  {
   *    name: string;
   *    description?: string;
   *    start_at: string;
   *    end_at: string;
   *    organizer_id?: number; // Для департаментов или операторов
   *  };
   */
  create(payload) {
    return apiService.post(PATH, payload);
  },
  /**
   *  {
   *    organizer_id: number;
   *    region_id: number;
   *  };
   */
  createSorted(payload) {
    return apiService.post('/announcements', payload);
  },
  /**
   *  {
   *    name: string;
   *    description?: string;
   *    start_at: string;
   *    end_at: string;
   *    organizer_id?: number; // Для департаментов или операторов
   *  };
   */
  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },
  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },
  /**
   *  {
   *    event_id: number;
   *  };
   */
  attachEvent(id, payload) {
    return apiService.post(`${PATH}/${id}/attach-event`, payload);
  },
  /**
   *  {
   *    event_id: number;
   *  };
   */
  detachEvent(id, payload) {
    return apiService.post(`${PATH}/${id}/detach-event`, payload);
  },
  /**
   *  Для модерации департаментом или оператором
   *  {
   *    organizer_id?: number;
   *    region_id?: number;
   *    municipality_id?: number;
   *    event_association_id?: number;
   *  };
   */
  request(id, payload) {
    return apiService.post(`${PATH}/${id}/request`, payload);
  },
  /**
   *  Для модерации департаментом или оператором
   *  {
   *    organizer_id?: number;
   *    region_id?: number;
   *    municipality_id?: number;
   *    event_association_id?: number;
   *  };
   */
  accept(id, payload) {
    return apiService.post(`${PATH}/${id}/accept`, payload);
  },
  /**
   *  Для модерации департаментом или оператором
   *  {
   *    organizer_id?: number;
   *    region_id?: number;
   *    municipality_id?: number;
   *    event_association_id?: number;
   *  };
   */
  reject(id, payload) {
    return apiService.post(`${PATH}/${id}/reject`, payload);
  },
  /**
   *  Для модерации департаментом или оператором
   *  {
   *    organizer_id?: number;
   *    region_id?: number;
   *    municipality_id?: number;
   *    event_association_id?: number;
   *  };
   */
  detach(id, payload) {
    return apiService.post(`${PATH}/${id}/detach`, payload);
  },
};
